"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AuthProvider = exports.AuthContext = exports.AuthConsumer = void 0;
var _react = require("react");
var authContext = /*#__PURE__*/(0, _react.createContext)({
  authenticated: false,
  // to check if authenticated or not
  businessUserId: "",
  // Business user id
  user: {},
  // store all the user details
  authToken: "",
  // accessToken of user for Auth0
  organizationId: "",
  // organizationID
  initiateLogin: function initiateLogin() {},
  // to start the login process
  handleAuthentication: function handleAuthentication() {},
  // handle Auth0 login process,
  setUserRoles: function setUserRoles() {},
  // Set user roles data
  logout: function logout() {},
  // logout the user
  setApplication: function setApplication() {},
  // Set application id such as (cxc, sxc, bxc, etc)
  setStoreId: function setStoreId() {},
  // Set store ids for the user
  onlineStoreId: "",
  application: ""
});
var AuthProvider = authContext.Provider;
exports.AuthProvider = AuthProvider;
var AuthConsumer = authContext.Consumer;
exports.AuthConsumer = AuthConsumer;
var AuthContext = authContext;
exports.AuthContext = AuthContext;